// Convert Arabic-Indic and Persian digits to Western Arabic digits.
const MAP: Record<string, string> = {
  "٠": "0", "١": "1", "٢": "2", "٣": "3", "٤": "4",
  "٥": "5", "٦": "6", "٧": "7", "٨": "8", "٩": "9",
  "۰": "0", "۱": "1", "۲": "2", "۳": "3", "۴": "4",
  "۵": "5", "۶": "6", "۷": "7", "۸": "8", "۹": "9",
};

export function normalizeDigits(input: string): string {
  if (!input) return input;
  let out = "";
  for (const ch of input) out += MAP[ch] ?? ch;
  return out;
}
